import React, { useEffect, useState } from "react"

function ShareJob({ job }) {
    return (
        <div>
            <span className="share-msg">Partager cette offre</span>
            <a className="share-facebook" target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}>
                <span>facebook</span>
            </a>
            <a className="share-twitter" target="_blank" href={`http://twitter.com/share?text=${job.title}&url=${window.location.href}&hashtags=${job.contract_type_abbreviation}`}>
                <span>twitter</span>
            </a>
            <a className="share-linkedin" target="_blank" href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`}>
                <span>linkedin</span>
            </a>
            <a className="share-mailto" href={`mailto:?subject=${job.title}&body=Lien de l'offre : ${window.location.href}`} title="Share by Email">
                <span>mailto</span>
            </a>
        </div>
    )
}

function Job({ job, closeJob }) {
    let fields = [
        { title: "Notre entreprise", name: "employer_description" },
        { title: "Vos missions", name: "position_description" },
        { title: "Vos différences qui comptent", name: "profile_description" },
    ]

    const [siteurl, setSiteurl] = useState("")

    function postulerClickTags(e) {
        window._zbo.register("lead")
        // if (window.tag && job.categorisation_pour_tag) {
        if (window.tC && job.categorisation_pour_tag) {
            // window.tag.click.send({ elem: e.target, name: job.categorisation_pour_tag + "_JE_POSTULE", type: "navigation" })
            window.tC.event.AtClick(e.target, { evt_action_libelle: job.categorisation_pour_tag + "_JE_POSTULE" })
        }
    }

    // function initATInternet() {
    //     if (typeof window.ATInternet !== "undefined") {
    //         window.tag = new window.ATInternet.Tracker.Tag({ site: 602755 })
    //     }
    // }

    useEffect(() => {
        // console.log("job useeffect")

        if (window.wami_js) {
            setSiteurl(window.wami_js.siteurl)
        }

        // if (typeof window.tag === "undefined") {
        //     initATInternet()
        // }

        // if (typeof window.tag !== "undefined" && job.categorisation_pour_tag) {
            // window.tag.page.send({ name: "FO_" + job.categorisation_pour_tag })
            // window.tag.dispatch()
            window.tc_vars = {}
            window.tc_vars.page_nom = "FO_" + job.categorisation_pour_tag
        // }
    }, [])

    let temoignage = ""
    if (job.isSiegeSocial && document.getElementById("temoignage_siege")) {
        temoignage = document.getElementById("temoignage_siege").innerHTML
    } else if (document.getElementById("temoignage_reseau")) {
        temoignage = document.getElementById("temoignage_reseau").innerHTML
    }

    return (
        <div>
            <div className="JobHeader">
                <h1>{job.title}</h1>

                <div>
                    <span>{job.contract_type_abbreviation}</span>
                    {job.isSiegeSocial ? <span className="tag tag-green">Siège social</span> : <span className="tag tag-red">Réseau d'agences</span>}
                </div>

                <p>{job.localisation}</p>

                <a href={job.apply_web_url} onClick={postulerClickTags} target="_blank" className="c-button c-button--red">
                    <i className="fas fa-2x fa-arrow-right"></i>
                    Postulez à cette offre
                </a>
            </div>

            <p className="breadcrumb">
                <span>
                    <a href={siteurl}>{"Accueil"}</a>
                    {" » "}
                    <a href="../">{"Carrières"}</a>
                    {" » "}
                    <a href="./" onClick={closeJob}>
                        {"Nos offres d'emploi"}
                    </a>
                    {" » "}
                    <span className="breadcrumb_last" aria-current="page">
                        {job.title}
                    </span>
                </span>
            </p>

            <div className="u-background-darker o-grid__wrapper u-pt-8 u-pb-10 u-pt-6-m u-pb-6-m">
                <div className="o-grid__wrapper">
                    <div className="o-grid u-justify-content-center-m">
                        <div className="o-grid__col is-7 has-ml-1 is-10-m has-ml-0-m">
                            <a href="../" onClick={closeJob} className="c-button c-button--primary">
                                &lt; &nbsp; Retour à la recherche
                            </a>

                            <ShareJob job={job} />

                            {fields.map((f, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <h2>{f.title}</h2>
                                        <p dangerouslySetInnerHTML={{ __html: job[f.name] }}></p>
                                    </React.Fragment>
                                )
                            })}

                            <a href={job.apply_web_url} onClick={postulerClickTags} target="_blank" className="c-button c-button--red">
                                <i className="fas fa-2x fa-arrow-right"></i>
                                Postulez à cette offre
                            </a>
                        </div>
                        <div className="o-grid__col is-3 is-3-l is-10-m bloc-border">
                            <div className="job-temoignage job-temoignage-siege" dangerouslySetInnerHTML={{ __html: temoignage }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Job
